/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
const isJSON = (data) => {
    try {
        return JSON.parse(data)
    } catch (e) {
        return data
    }
}

const mutations = {


    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    createSession(state) {
    },

    SET_WRAPPER_WIDTH(state, value) {
        state.wrapperWidth = value
    },
    TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
        state.isVerticalNavMenuActive = value
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val
    },
    UPDATE_MAIN_LAYOUT_TYPE(state, val) {
        state.mainLayoutType = val
    },
    UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
        state.verticalNavMenuItemsMin = val
    },
    UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
        state.verticalNavMenuWidth = width
    },
    AJAX_REQUEST(state, data) {
        state.ajaxRequest = data
    },


    // VxAutoSuggest

    UPDATE_STARRED_PAGE(state, payload) {

        // find item index in search list state
        const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

        // update the main list
        state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

        // if val is true add it to starred else remove
        if (payload.val) {
            state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
        } else {
            // find item index from starred pages
            const index = state.starredPages.findIndex((item) => item.url == payload.url)

            // remove item using index
            state.starredPages.splice(index, 1)
        }
    },

    // Navbar-Vertical

    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
        const starredPagesMore = state.starredPages.slice(10)
        state.starredPages = list.concat(starredPagesMore)
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
        let downToUp = false
        let lastItemInStarredLimited = state.starredPages[10]
        const starredPagesLimited = state.starredPages.slice(0, 10)
        state.starredPages = starredPagesLimited.concat(list)

        state.starredPages.slice(0, 10).map((i) => {
            if (list.indexOf(i) > -1) downToUp = true
        })

        if (!downToUp) {
            state.starredPages.splice(10, 0, lastItemInStarredLimited)
        }
    },


    // ////////////////////////////////////////////
    // UI
    // ////////////////////////////////////////////

    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val
    },
    UPDATE_PRIMARY_COLOR(state, val) {
        state.themePrimaryColor = val
    },
    UPDATE_THEME(state, val) {
        state.theme = val
    },
    UPDATE_WINDOW_WIDTH(state, width) {
        state.windowWidth = width
    },
    UPDATE_WINDOW_SCROLL_Y(state, val) {
        state.scrollY = val
    },


    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    // Updates user info in state and localstorage
    UPDATE_USER_INFO(state, payload) {
        for (const property of Object.keys(payload)) {

            if (payload[property] != null) {
                // If some of user property is null - user default property defined in state.UsersTable
                state.UsersTable[property] = payload[property]
            }
        }
    },

    SET_USER_PERMISSIONS(state, payload) {
        let permissions = {}
        payload.forEach(val => {
            if (!permissions[val.model.slug]) permissions[val.model.slug] = []
            permissions[val.model.slug].push(val.permission.slug)
            // Object.assign(permissions, val.model.name, val.permission.name)
        })
        state.userPermissions = permissions
    },

    SET_SYSTEM_SETTINGS(state, payload) {
        state.systemSettings = payload
    },

    SET_USER_INFO(state, payload) {
        for (const property of Object.keys(payload)) {

            if (payload[property] != null) {
                // If some of user property is null - user default property defined in state.UsersTable
                state.AppActiveUser[property] = payload[property]
            }
        }
    },

    SET_AUTOLOGIN_USER(state, payload) {
        Object.assign(state.aUser, payload)
    },

    SET_USER_FIELDS(state, {event, display}) {
        const params = isJSON(state.AppActiveUser.lead_statistic_fields)
        if (params) {
            params[event] = display
            state.AppActiveUser.lead_statistic_fields = JSON.stringify(params)
        }
    },

    CLEAR_AUTHUSER(state) {
        state.aUser = {
            color_scheme: null,
            created_at: null,
            dashboard: null,
            email: null,
            email_verified_at: null,
            hash: null,
            id: null,
            is_active: null,
            locale: null,
            menu_state: null,
            name: null,
            permissions: null,
            role_id: null,
            team: null,
            roles: {
                name: null
            },
            team_id: null,
            updated_at: null,
            photoURL: require("@assets/images/portrait/small/avatar-s-11.jpg"),
        }
    },

    SET_TEAMS_AUTOLOGIN(state, payload) {
        state.isTeamAutologin = payload
    }
}

export default mutations

